import { ApolloCache, gql } from '@apollo/client';

const PROJECT_ADDRESS_ID_FRAGMENT = gql`
  fragment ProjectAddressId on Project {
    id
    addressId
  }
`;

/** Rewrites the cached `primaryProjectId` of the site that a cached project belongs to. */
export function updateCachedPrimaryProjectId(
  cache: ApolloCache<unknown>,
  projectId: string,
  next: (primaryProjectId: string | null) => string | null,
): void {
  const project = cache.readFragment<{ addressId: string | null }>({
    id: cache.identify({ __typename: 'Project', id: projectId }),
    fragment: PROJECT_ADDRESS_ID_FRAGMENT,
  });
  if (!project?.addressId) {
    return;
  }
  cache.modify({
    id: cache.identify({ __typename: 'Address', id: project.addressId }),
    fields: {
      primaryProjectId: (existing: string | null) => next(existing),
    },
  });
}
